import {
  Col,
  Popconfirm,
  Row,
  Modal as AntModal,
  Upload,
  Button as AntButton,
  Tooltip,
  Typography,
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
// import * as Icon from "react-icons/all";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import userLive from "../../assets/images/userLive.png";
import clockLive from "../../assets/images/clockLive.png";
import {
  Button,
  Modal,
  Pagination,
  Table,
  Text,
  TextField,
} from "../../components";
import { Colors, Images } from "../../config";
import styles from "./index.module.css";
import Fonts, {
  MontserratBold,
  MontserratLight,
  MontserratRegular,
  MontserratSemiBold,
} from "../../config/fonts";
import { LiveAction, MediaAction, UserAction } from "../../store/actions";
import { UploadOutlined } from "@ant-design/icons";
import { FaEye, FaSearch, FaUserCircle } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";
import { MdEmail, MdDelete } from "react-icons/md";
import AdminLiveStreamModal from "../../components/LiveStreamModal";
import { useDebounce } from "../../config/util";
import { IoReloadCircle } from "react-icons/io5";

function LiveStreaming() {
  const BUCKET = process.env.REACT_APP_MEDIA_BASE_URL;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mediaListing = useSelector((state) => state.media);
  const liveStreams = useSelector((state) => state.live);
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [liveType, setLiveType] = useState("past");
  const [search, setSearch] = useState("");
  const [selectedOrgnizer, setSelectedOrganizer] = useState(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailForm, setEmailForm] = useState({
    message: "",
    attachments: [],
  });
  const [isBulkEmailModalOpen, setIsBulkEmailModalOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [streamTypeSearch, setStreamTypeSearch] = useState("");
  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    sort_by: "date",
    order: "desc",
    media_type: "",
    media_category: "",
    title: "",
  });

  const debouncedSearch = useDebounce(search, 500);
  const debouncedStreamTypeSearch = useDebounce(streamTypeSearch, 500);

  const data = {
    liveType,
    page,
    search: debouncedSearch,
    streamTypeSearch: debouncedStreamTypeSearch,
  };
  useEffect(() => {
    dispatch(LiveAction.getLiveStreaming(data));
  }, [state, page, liveType, debouncedSearch, debouncedStreamTypeSearch]);

  const handlePagination = (pageNumber) => {
    let offset = (pageNumber - 1) * state.limit;
    setState({ ...state, offset: offset });
    setPage(pageNumber);
  };

  const handleDeleteSong = (record) => {
    setShowDetail(record);
    setShowModal(true);
    // dispatch(
    //   MediaAction.deleteMedia(id, () => {
    //     dispatch(MediaAction.getMediaListing(state));
    //   })
    // );
  };

  const handleDeleteStream = (id) => {
    dispatch(LiveAction.deleteEvent(id));
  };

  const handleOpenEmailModal = (record) => {
    // record might be the stream object, prefer organizer object when available
    const org = record?.organizer ? record.organizer : record;
    setSelectedOrganizer(org);
    setIsEmailModalOpen(true);
  };

  const handleCloseEmailModal = () => {
    setIsEmailModalOpen(false);
    setSelectedOrganizer(null);
    setEmailForm({ message: "", attachments: [] });
  };

  const handleFileChange = (info) => {
    const validFiles = info.fileList
      .filter((f) => f.originFileObj)
      .map((f) => f.originFileObj);
    setEmailForm({ ...emailForm, attachments: validFiles });
  };

  const handleOpenBulkEmailModal = () => {
    setIsBulkEmailModalOpen(true);
  };

  const handleCloseBulkEmailModal = () => {
    setIsBulkEmailModalOpen(false);
    setEmailForm({ message: "", attachments: [] });
  };

  const handleSendBulkEmail = () => {
    if (!emailForm.message) return;
    // Submit bulk email to events endpoint with status = liveType
    const payload = {
      message: emailForm.message,
      attachments: emailForm.attachments,
      status: liveType, // 'past' | 'upcoming' | 'live'
    };
    dispatch(
      LiveAction.sendEventEmail(payload, () => {
        handleCloseBulkEmailModal();
      })
    );
  };

  const handleSendEmail = () => {
    if (!emailForm.message || !selectedOrgnizer) return;
    const payload = {
      user_id: selectedOrgnizer.id,
      message: emailForm.message,
      attachments: emailForm.attachments,
    };
    dispatch(
      UserAction.sendUserEmail(payload, () => {
        handleCloseEmailModal();
      })
    );
  };

  const handleRefreshTab = () => {
    dispatch(LiveAction.getLiveStreaming(data));
  };

  const tableData = useMemo(
    () => liveStreams?.liveStreams || [],
    [liveStreams?.liveStreams]
  );

  const tableColumns = useMemo(() => {
    // 1. SHARED COLUMNS (Present in all states)
    const columns = [
      {
        title: "S.No.",
        dataIndex: "id",
        key: "id",
        render: (text, record, index) => (
          <span className="table-cell">
            {String(index + 1).padStart(2, "0")}
          </span>
        ),
      },
      {
        title: "Artist Name",
        dataIndex: "organizer",
        key: "artist_name",
        render: (organizer) => (
          <span className="table-cell">{organizer?.name}</span>
        ),
      },
      {
        title: "Live Streaming Title",
        dataIndex: "title",
        key: "title",
        render: (text) => <span className="table-cell">{text}</span>,
      },
      {
        title: "Live Streaming Date",
        dataIndex: "start_datetime",
        key: "date",
        render: (date) => (
          <span className="table-cell">
            {moment.utc(date).local().format("DD MMM, YYYY")}
          </span>
        ),
      },
    ];

    // 2. CONDITIONAL COLUMNS BASED ON LIVETYPE
    if (liveType === "past" || liveType === "live") {
      columns.push(
        {
          title: "Audience",
          dataIndex: "total_viewers",
          render: (val) => <span className="table-cell">{val || 0}</span>,
        },
        {
          title: "Video File No.",
          render: (_, record) =>
            record.recording_path ? (
              <Tooltip title={record?.recording_path}>
                <Typography.Text
                  ellipsis={{ tooltip: false }}
                  style={{ maxWidth: 150, display: "inline-block" }}
                  className="table-cell"
                >
                  {record?.recording_path}
                </Typography.Text>
              </Tooltip>
            ) : (
              <span className="table-cell">N/A</span>
            ),
        },
        {
          title: "Duration",
          render: (_, record) => {
            if (!record.started_at || !record.ended_at)
              return <span className="table-cell">{"--:--"}</span>;
            const diff = moment
              .utc(record.ended_at)
              .diff(moment.utc(record.started_at), "minutes");
            return <span className="table-cell">{`${diff} min`}</span>;
          },
        },
        {
          title: "Cancelled",
          render: (_, record) => (
            <span className="table-cell">
              {record?.status === "cancelled" ? "Yes" : "No"}
            </span>
          ),
        },
        {
          title: "No Show",
          render: (_, record) => (
            <span className="table-cell">
              {record.status === "not-shown" ? "Yes" : "No"}
            </span>
          ),
        }
      );
    } else if (liveType === "upcoming") {
      columns.push(
        {
          title: "Start Time",
          dataIndex: "start_datetime",
          render: (date) => (
            <span className="table-cell">
              {moment.utc(date).local().format("hh:mm A")}
            </span>
          ),
        },
        {
          title: "Finish Time",
          dataIndex: "end_datetime",
          render: (date) => (
            <span className="table-cell">
              {moment.utc(date).local().format("hh:mm A")}
            </span>
          ),
        },
        {
          title: "Rescheduled",
          render: (_, record) => (
            <span className="table-cell">
              {record.status === "scheduled" ? "Yes" : "No"}
            </span>
          ),
        },
        {
          title: "Cancelled",
          render: (_, record) => (
            <span className="table-cell">
              {record.status === "cancelled" ? "Yes" : "No"}
            </span>
          ),
        }
      );
    }

    columns.push({
      title: "Email",
      key: "email",
      render: (text, record) => (
        <div className="flex items-center gap-2">
          <MdEmail
            className="cursor-pointer"
            color={Colors.BlueText}
            size={24}
            title="Email Organizer"
            onClick={() => handleOpenEmailModal(record)}
          />
        </div>
      ),
    });

    if (liveType !== "upcoming") {
      columns.push({
        title: "View",
        key: "view",
        render: (text, record) => (
          <div className="flex items-center gap-2">
            <FaEye
              className="cursor-pointer"
              color={"#afc8e9"}
              size={24}
              title="View Details"
              onClick={() => handleDeleteSong(record)}
            />
          </div>
        ),
      });
    }
    if (liveType !== "past") {
      columns.push({
        title: "Artist Photo",
        key: "artist_photo",
        render: (text, record) => (
          <div className="flex items-center gap-2">
            <AntButton
              type="link"
              onClick={() => {
                // const path = record?.media?.[0]?.path;
                const path = record?.organizer?.profile_photo;
                setImageSrc(path);
                setImageModalOpen(true);
              }}
            >
              <FaUserCircle
                className="cursor-pointer"
                color={Colors.BlueText}
                size={24}
              />
            </AntButton>
          </div>
        ),
      });
    }

    if (liveType !== "upcoming") {
      columns.push({
        title: "Delete",
        key: "delete",
        render: (text, record) => (
          <div className="flex items-center gap-2">
            {/* Delete Only for Past and Live */}
            {liveType !== "upcoming" && (
              <Popconfirm
                title="Delete this stream?"
                onConfirm={() => handleDeleteStream(record.id)}
              >
                <MdDelete
                  size={24}
                  color="#FF606B"
                  className="cursor-pointer"
                />
              </Popconfirm>
            )}
          </div>
        ),
      });
    }

    return columns;
  }, [liveType, BUCKET, handleDeleteStream]);

  return (
    <div className="wrapper">
      {/* <Row className="flex-row-space-center mb-5 mx-15"> */}
      {/* <Col className="" > */}
      <div className="flex items-center justify-between  mb-4">
        <div>
          <Text.Basic
            text="Live Streaming Media"
            color={Colors.Black}
            fontSize={25}
            fontWeight={600}
            fontFamily={Fonts[MontserratBold]}
            textAlign="left"
          />
          <span
            style={{
              width: "8px",
              height: "8px",
              background: "#7836FF",
              borderRadius: "50px",
              marginInline: "10px",
            }}
          ></span>
          <Text.Basic
            text={liveStreams?.pagination?.total}
            color={Colors.Black}
            fontSize={18}
            fontWeight={400}
            fontFamily={Fonts[MontserratRegular]}
            textAlign="left"
          />
        </div>
      </div>

      <Row className="flex-row justify-between align-center">
        <Col className="flex-row mb-10 mt-5 items-center">
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor:
                liveType === "past" ? Colors.BlueText : Colors.LightBlue,
              borderRadius: "5px 0px 0px 5px",
              color: liveType === "past" ? Colors.White : Colors.Black,
            }}
            onClick={() => setLiveType("past")}
            text={"Past"}
          />
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor:
                liveType === "upcoming" ? Colors.BlueText : Colors.LightBlue,
              borderRadius: "0px 0px 0px 0px",
              color: liveType === "upcoming" ? Colors.White : Colors.Black,
            }}
            onClick={() => setLiveType("upcoming")}
            text={"Up Coming"}
          />
          <Button.Basic
            size={"large"}
            buttonStyle={{
              backgroundColor:
                liveType === "live" ? Colors.BlueText : Colors.LightBlue,
              borderRadius: "0px 5px 5px 0px",
              color: liveType === "live" ? Colors.White : Colors.Black,
            }}
            onClick={() => setLiveType("live")}
            text={"Live"}
          />

          <IoReloadCircle
            size={44}
            color={Colors.BlueText}
            className="ml-3 cursor-pointer"
            onClick={handleRefreshTab}
          />
        </Col>
        <Row className="gap-2 mb-3 xl:mb-auto">
          <Col>
            <Select
              className="listing-filter"
              size="large"
              placeholder="Select Live Stream Type"
              value={streamTypeSearch || undefined}
              onChange={(value) => setStreamTypeSearch(value || "")}
              allowClear
              style={{ minWidth: 220 }}
            >
              <Select.Option value="">All</Select.Option>
              <Select.Option value="concert">Concert</Select.Option>
              <Select.Option value="event">Event</Select.Option>
              <Select.Option value="podcast">Podcast</Select.Option>
            </Select>
          </Col>
          <Col>
            <TextField.IconField
              className="listing-filter"
              size={"large"}
              suffix={<FaSearch />}
              placeholder={"Search Events By Artist Name"}
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </Col>
          <Col
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button.Basic
              text="Email All"
              onClick={handleOpenBulkEmailModal}
              type="primary"
              buttonStyle={{ height: "40px" }}
            />
          </Col>
        </Row>
      </Row>

      <Table.Basic
        bordered={false}
        scroll={{ x: "max-content" }}
        columns={tableColumns}
        data={tableData}
        loading={liveStreams?.isLoading}
      />

      {liveStreams?.pagination?.total > 10 && (
        <Row justify={"center"} className="mt-10">
          <Col>
            <Pagination.Basic
              onChange={handlePagination}
              pageSize={10}
              current={page}
              total={liveStreams?.pagination?.total}
            />
          </Col>
        </Row>
      )}

      {imageModalOpen && (
        <Modal.Basic
          className="modal-lg"
          centered={true}
          title=""
          open={imageModalOpen}
          handleCancel={() => {
            setImageModalOpen(false);
            setImageSrc(null);
          }}
        >
          <Row justify="center">
            <Col>
              {/* <div className="flex justify-center items-center">
                <img
                  src={imageSrc}
                  alt="Artist"
                  style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: 12 }}
                />
              </div> */}
              <div className="flex justify-center items-center min-h-[70vh]">
                {imageSrc ? (
                  <img
                    src={BUCKET + imageSrc}
                    alt="Artist"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      borderRadius: 12,
                    }}
                  />
                ) : (
                  <h2 className="text-gray-900  text-3xl">
                    Profile photo not available
                  </h2>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Basic>
      )}

      {showModal && liveType === "live" && (
        <AdminLiveStreamModal
          showDetail={showDetail}
          setShowDetail={setShowDetail}
          setShowModal={setShowModal}
          showModal={showModal}
        />
      )}

      {showModal && liveType !== "live" && (
        <Modal.Basic
          className="modal-lg"
          centered={true}
          title=""
          open={showModal}
          handleCancel={() => {
            setShowDetail(null);
            setShowModal(false);
            //   setFeedbackDetails({});
          }}
        >
          <Row className="flex justify-center">
            <Col>
              <Text.Basic
                color={Colors.Black}
                fontSize={22}
                fontWeight={600}
                fontFamily={Fonts[MontserratBold]}
                text={
                  // feedbackDetails?.type === "Feedback Media Reply"
                  //   ? ""
                  //   :
                  showDetail.title
                }
              />
            </Col>
          </Row>
          {showDetail?.recording_path ? (
            <div>
              <Row justify="center">
                <Col span={24} className="flex-row-align-center">
                  <div className="w-full h-auto mt-2">
                    <video
                      src={BUCKET + `${showDetail?.recording_path}`}
                      controls
                      style={{
                        width: "100%",
                        height: "300px", // adjust as needed
                        objectFit: "contain",
                        borderRadius: "12px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <div className="mt-4 flex justify-between">
                <p className="font-bold">{showDetail?.organizer?.name}</p>
                <div className="flex items-center gap-2">
                  <img src={clockLive} className="w-4 h-4" />
                  <p>
                    {"Duration: " +
                      moment
                        .utc(showDetail?.ended_at)
                        .diff(moment.utc(showDetail?.started_at), "minutes")}
                  </p>
                </div>
              </div>
              <div className="mt-4 flex justify-between">
                <p>
                  {moment
                    .utc(showDetail?.started_at)
                    .local()
                    .format("DD MMM, YYYY") +
                    " at " +
                    moment
                      .utc(showDetail?.started_at)
                      .local()
                      .format("hh:mm A")}
                </p>
                <div className="flex items-center gap-2">
                  <img src={userLive} className="w-6 h-4" />
                  <p>{showDetail?.total_viewers + " People Attending"}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full flex justify-center items-center h-48">
              <Text.Basic
                color={Colors.Black}
                fontSize={22}
                fontWeight={600}
                fontFamily={Fonts[MontserratBold]}
                text={
                  // feedbackDetails?.type === "Feedback Media Reply"
                  //   ? ""
                  //   :
                  "Video URL Not Found"
                }
              />
            </div>
          )}

          {/* <Row className="mt-20 modal-textarea">
                  <Col span={24}>
                    <TextField.Textarea
                      value={reply}
                      placeholder={"Write your message here"}
                      rows={4}
                      handleChange={(e) => setReply(e.target.value)}
                    />
                    <Text.Error text={replyError} />
                  </Col>
                </Row> */}
          {/* <Row className="mt-20 flex-end">
                  <Col>
                    <Button.Basic
                      text="Reply"
                      size={"large"}
                      onClick={handelReplyFeedback}
                      buttonStyle={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: Colors.BlueText,
                        color: Colors.White,
                        fontSize: "16px",
                        fontFamily: Fonts[PoppinsMedium],
                        borderRadius: "10px",
                        border: "none",
                      }}
                    />
                  </Col>
                </Row> */}
        </Modal.Basic>
      )}
      {/* Email to Organizer Modal */}
      <AntModal
        title="Send Email to Organizer"
        open={isEmailModalOpen}
        onCancel={handleCloseEmailModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseEmailModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="send"
            type="primary"
            onClick={handleSendEmail}
            disabled={!emailForm.message}
          >
            Send
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Name</label>
          <TextField.IconField
            value={selectedOrgnizer?.name || ""}
            disabled
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Email</label>
          <TextField.IconField
            value={selectedOrgnizer?.email || ""}
            disabled
            style={{ marginTop: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Message</label>
          <TextField.Textarea
            rows={4}
            value={emailForm.message}
            onChange={(e) =>
              setEmailForm({ ...emailForm, message: e.target.value })
            }
            placeholder="Type your message here..."
            style={{ marginTop: "8px" }}
          />
        </div>
        <div className="gap-4">
          <label style={{ fontWeight: "bold" }}>Attachments</label>
          <div>
            <Upload
              multiple
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={emailForm.attachments.map((file, idx) => ({
                uid: idx,
                name: file.name,
                status: "done",
                originFileObj: file,
              }))}
            >
              <AntButton icon={<UploadOutlined />} style={{ marginTop: "8px" }}>
                Select Files
              </AntButton>
            </Upload>
          </div>
        </div>
      </AntModal>

      {/* Bulk Email Modal (UI only) */}
      <AntModal
        title={`Send Email to All (${
          liveType.charAt(0).toUpperCase() + liveType.slice(1)
        })`}
        open={isBulkEmailModalOpen}
        onCancel={handleCloseBulkEmailModal}
        footer={[
          <AntButton key="cancel" onClick={handleCloseBulkEmailModal}>
            Cancel
          </AntButton>,
          <AntButton
            key="send"
            type="primary"
            onClick={handleSendBulkEmail}
            disabled={!emailForm.message}
          >
            Send
          </AntButton>,
        ]}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold" }}>Message</label>
          <TextField.Textarea
            rows={4}
            value={emailForm.message}
            onChange={(e) =>
              setEmailForm({ ...emailForm, message: e.target.value })
            }
            placeholder="Type your message here..."
            style={{ marginTop: "8px" }}
          />
        </div>
        <div>
          <label style={{ fontWeight: "bold" }}>Attachments</label>
          <div>
            <Upload
              multiple
              beforeUpload={() => false}
              onChange={handleFileChange}
              fileList={emailForm.attachments.map((file, idx) => ({
                uid: idx,
                name: file.name,
                status: "done",
                originFileObj: file,
              }))}
            >
              <AntButton icon={<UploadOutlined />} style={{ marginTop: "8px" }}>
                Select Files
              </AntButton>
            </Upload>
          </div>
        </div>
      </AntModal>
    </div>
  );
}

export default LiveStreaming;
